/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef, useCallback, memo } from "react";
import { MultiProductCardProps } from "../../Services/CommonServices/propTypes";
import { useSelector } from 'react-redux';
import { fetchBrandImage, formatLabel } from "../../Services/CommonServices/helper";
import { brandMap } from "../../Services/BrandName";
import MultiProductLoaderCard from "./MultiProductLoaderCard";

// Wrap with memo to prevent unnecessary re-renders
const MultiProductCard = memo(function MultiProductCard({
  productIndex,
  product,
  products,
  cardLength,
  isAnswerComplete,
  setIsProductLoading,
  effects,
  categoryListing,
  stopHover,
  stopClick
}) {
  const loading = useSelector((state) => state.common.isLoader);

  // Move mutable variables to useRef to persist between renders without causing re-renders
  const dataRef = useRef({
    categoryObjectMapArray: [],
    onlyCats: [],
    processedProductId: null
  });

    let IsLuxeBrand = [];

    if(products) {
      IsLuxeBrand = products?.map(item => {
        const products = item?.products ?? [];
        console.log(products, 'products');

        if (products?.length === 0) return "";

        const firstBrand = products[0].brandName;
        const allLuxe = products.every(p => p.isLuxe);
        const sameBrand = products.every(p => p.brandName === firstBrand);

        return allLuxe && sameBrand ? firstBrand : "";
      });
    }

  // Memoize functions to prevent recreation on every render
  const getClassName = useCallback((index) => {
    if (index === 0) return "coat1 animation-coat";
    if (index === 1) return "shirt1 animation-shirt";
    if (index === 2) return "pant1 animation-pant";
    if (index === 3) return "watch1 animation-watch";
  }, []);

  // Categories restricted for RRL brand
  const RRL_RESTRICTED_CATEGORIES = ["TAILORED CLOTHING", "HEADWEAR", "NECKWEAR"];

  // Check if current product is RRL brand
  const isRRLBrand = product?.products?.length > 0 &&
    product?.products?.every(p => p.brandName === "RRL");

  const slotHierarchy = {
    slot0: [
      "OUTERWEAR",
      "JACKET",
      "TAILORED CLOTHING",
      "DRESSES",
      "SWEATER",
      "SHIRTS",
      "TOPS",
      "KNIT SHIRTS",
      "SWIMWEAR",
      "ONE PIECE",
      "INTIMATE",
      "SLEEPWEAR"

    ],
    slot1: [
      "TAILORED CLOTHING",
      "DRESSES",
      "SWEATER",
      "SHIRTS",
      "TOPS",
      "KNIT SHIRTS",
      "BOTTOMS",
      "SHORTS",
      "SWIMWEAR",
      "ONE PIECE",
      "JEANS",
      "PANTS",
      "SKIRT",
      "SKORTS",
      "INTIMATE",
      "SLEEPWEAR",
      "BELTS",
      "NECKWEAR",
      "HEADWEAR",
      "BAGS",
      "EYEWEAR",
      "FINE JEWELRY",
      "FASHION JEWELRY",
      "HOSIERY",
      "SCARF",
      "GLOVES",
      "SMALL LEATHERGOODS",
      "APPAREL ACCESSORIES",
      "SMALL ACCESSORIES",
    ],
    slot2: [
      "TAILORED CLOTHING",
      "SWEATER",
      "SHIRTS",
      "TOPS",
      "KNIT SHIRTS",
      "BOTTOMS",
      "SHORTS",
      "SWIMWEAR",
      "ONE PIECE",
      "JEANS",
      "PANTS",
      "SKIRT",
      "SKORTS",
      "INTIMATE",
      "SLEEPWEAR",
      "BELTS",
      "NECKWEAR", 
      "HEADWEAR",
      "BAGS",
      "EYEWEAR",
      "FINE JEWELRY",
      "FASHION JEWELRY",
      "HOSIERY",
      "SCARF",
      "GLOVES",
      "SMALL LEATHERGOODS",
      "APPAREL ACCESSORIES",
      "SMALL ACCESSORIES",
    ],
    slot3: [
      "BAGS",
      "FOOTWEAR",
      "BOOTS",
      "SHOE",
      "SNEAKERS",
      "SANDALS",
      "SLIP-ONS",
      "FLATS",
      "DRESS SHOE",
      "CASUAL SHOE",
      "ESPADRILLES",
      "CLOG",
      "PUMPS",
      "BELTS",
      "NECKWEAR",
      "HEADWEAR",
      //"BAGS",
      "EYEWEAR",
      "FINE JEWELRY",
      "FASHION JEWELRY",
      "HOSIERY",
      "SCARF",
      "GLOVES",
      "SMALL LEATHERGOODS",
      "APPAREL ACCESSORIES",
      "SMALL ACCESSORIES",
    ],
  };

  const [slotsData, setSlotsData] = useState([]);
  const [allSlotsReady, setAllSlotsReady] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  // Use useCallback to prevent recreating this function on every render
  const fetchImage = useCallback((
    slot,
    data,
    hierarchy
  ) => {
    // Use the ref values
    const { categoryObjectMapArray, onlyCats } = dataRef.current;

    let finaldata;

    if (slot === 0) {
      // Clear arrays on first slot
      categoryObjectMapArray.length = 0;
      onlyCats.length = 0;

      data?.forEach((element) => {
        // Exclude "PIN" product class from "FASHION JEWELRY" category
        if ((element.productCategory)?.toUpperCase() === "FASHION JEWELRY" && (element.productClass)?.toUpperCase() === "PIN") {
          return;
        }
        // Exclude "VEST" product class from "TAILORED CLOTHING" category for RRL brand
        if (isRRLBrand && (element.productCategory)?.toUpperCase() === "TAILORED CLOTHING" && (element.productClass)?.toUpperCase() === "VEST") {
          return;
        }
        // Exclude "HAT" product class from "HEADWEAR" category for RRL brand
        if (isRRLBrand && (element.productCategory)?.toUpperCase() === "HEADWEAR" && (element.productClass)?.toUpperCase() === "HAT") {
          return;
        }
        // Exclude "HAT" product class from "Neckwear" category for RRL brand
        if (isRRLBrand && (element.productCategory)?.toUpperCase() === "NECKWEAR") {
          return;
        }
        // Exclude "PONCHO" product class from "OUTERWEAR" category
        if ((element.productCategory)?.toUpperCase() === "OUTERWEAR" && (element.productClass)?.toUpperCase() === "PONCHO") {
          return;
        }
        // Exclude "GIFT BOX SET", "KEY FOB", "TECH CASE" product classes from "SMALL LEATHERGOODS" category and "GIFT BOX SET" from "SETS" category
        if (((element.productCategory)?.toUpperCase() === "SMALL LEATHERGOODS" || (element.productCategory)?.toUpperCase() === "SETS") && (element.productClass)?.toUpperCase() === "GIFT BOX SET") {
          return;
        }
        if ((element.productCategory)?.toUpperCase() === "SMALL LEATHERGOODS" && ((element.productClass)?.toUpperCase() === "KEY FOB" || (element.productClass)?.toUpperCase() === "TECH CASE")) {
          return;
        }
        // Exclude "SET" product class from "SLEEPWEAR" category
        if ((element.productCategory)?.toUpperCase() === "SLEEPWEAR" && (element.productClass)?.toUpperCase() === "SET") {
          return;
        }
        // Exclude "UNDERWEAR" product category
        if ((element.productCategory)?.toUpperCase() === "UNDERWEAR" && (element.productCategory)?.toUpperCase() ==="HOISERY") {
          return;
        }
        // Exclude "GOLF BAG" product class from "BAGS" category
        if ((element.productCategory)?.toUpperCase() === "BAGS" && (element.productClass)?.toUpperCase() === "GOLF BAG") {
          return;
        }
        // Exclude "GOLF" product class from "Umbrella" category
        if ((element.productCategory)?.toUpperCase() === "UMBRELLA" && (element.productClass)?.toUpperCase() === "GOLF" ) {
          return;
        }
        // Exclude "Plush" product class from "Umbrella" category
        if ((element.productCategory)?.toUpperCase() === "TOYS" && (element.productClass)?.toUpperCase() === "PLUSH" ) {
          return;
        }
        // Exclude "GOLF" product class from "SPORTS EQUIPMENT" category
        if ((element.productCategory)?.toUpperCase() === "SPORTS EQUIPMENT" && ((element.productClass)?.toUpperCase() === "GOLF" || (element.productClass)?.toUpperCase() === "GOLF BAGS")) {
          return;
        }
        // Exclude "Tuxedo" product class from "TAILORED CLOTHING" category
        if ((element.productCategory)?.toUpperCase() === "TAILORED CLOTHING" && (element.productClass)?.toUpperCase() === "TUXEDO") {
          return;
        }
        // Exclude "BLANKET" product class from "BABY ACCESSORIES" category
        if ((element.productCategory)?.toUpperCase() === "BABY ACCESSORIES" && (element.productClass)?.toUpperCase() === "BLANKET") {
          return;
        }
        // Exclude "2 Pc Set" product class from "Swimwear" category
        if ((element.productCategory)?.toUpperCase() === "SWIMWEAR" && (element.productClass)?.toUpperCase() === "2 PC SET") {
          return;
        }
        categoryObjectMapArray?.push({
          cat: element.productCategory, 
          element: element,
        });
        onlyCats?.push(element.productCategory);
      });
    }

    for (const category of hierarchy) {
      if (onlyCats?.includes(category)) {
        finaldata = categoryObjectMapArray?.find(
          (item) => item.cat === category
        );
        const prodIndex = onlyCats?.findIndex((item) => item === category);
        onlyCats?.splice(prodIndex, 1);
        categoryObjectMapArray?.splice(prodIndex, 1);
        break;
      }
    }

    // Batch state updates to reduce renders
    setSlotsData(prev => {
      const newData = [...prev, { "element": finaldata?.element || null, "slot": slot }];
      // Only set allSlotsReady when all slots are processed
      if (newData.length === 4) {
        // Use timeout to batch this state update
        setTimeout(() => setAllSlotsReady(true), 0);
      }
      return newData;
    });
  }, []);

  const imageTemplate = useCallback((productData, prodIndex) => {
    if (!productData) return null;

    const primaryImage = productData?.media?.find(imageUrl => imageUrl.type === "PrimaryImage");
    if (!primaryImage) return null;

    return (
      <img
        src={
          primaryImage?.url.split("?fmt=webp-alpha")[0] +
          "?$rl_5x7_pdp$&fmt=webp-alpha"
        }
        alt={productData?.name}
        data-testid={`product-image-${prodIndex}`}
        className={`img-fluid ${getClassName(prodIndex)}`}
        onError={(e) => {
          console.log("Image failed to load:", e);
        }}
      />
    );
  }, [getClassName]);

  const words = product?.name;

  // Handle completion status
  useEffect(() => {
    if (isAnswerComplete && products?.length === productIndex + 1) {
      setIsProductLoading(true);
    }
  }, [isAnswerComplete, products, productIndex, setIsProductLoading]);

  // Process products - fix dependency to 'product' instead of 'products'
  useEffect(() => {
    if (!product?.products) return;

    // Skip processing if we've already processed this product
    if (dataRef?.current?.processedProductId === product?.id) return;
    dataRef.current.processedProductId = product?.id;

    // Reset states for new product
    setSlotsData([]);
    setAllSlotsReady(false);
    setImagesLoaded(false);

    const slotsArray = [0, 1, 2, 3];

    // Process all slots in batch
    slotsArray?.forEach((element, index) => {
      const hierarchy = isRRLBrand
        ? slotHierarchy[`slot${index}`]?.filter(cat => !RRL_RESTRICTED_CATEGORIES.includes(cat))
        : slotHierarchy[`slot${index}`];
      fetchImage(index, product?.products, hierarchy);
    });
  }, [product, fetchImage, slotHierarchy, isRRLBrand, RRL_RESTRICTED_CATEGORIES]); // Note: correctly depends on product not products

  // Image preloading logic
  useEffect(() => {
    if (!allSlotsReady || slotsData.length !== 4) return;

    const imagesToPreload = [];

    slotsData?.forEach(slotItem => {
      if (slotItem.element && slotItem.element.media) {
        const primaryImage = slotItem.element.media.find(img => img.type === "PrimaryImage");
        if (primaryImage) {
          const imageUrl = primaryImage.url.split("?fmt=webp-alpha")[0] + "?$rl_5x7_pdp$&fmt=webp-alpha";
          imagesToPreload.push(imageUrl);
        }
      }
    });

    if (imagesToPreload?.length === 0) {
      setImagesLoaded(true);
      return;
    }

    setImagesLoaded(false);

    const preloadPromises = imagesToPreload?.map(url => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = url;
        img.onload = resolve;
        img.onerror = resolve;
      });
    });

    Promise.all(preloadPromises).then(() => {
      setImagesLoaded(true);
    });
  }, [allSlotsReady, slotsData]);

  // Memoize the card content to prevent unnecessary renders
  const cardContent = React.useMemo(() => (
    <div>
      {product?.loader ? (
        <div className="loader-card position-absolute d-flex">
          <MultiProductLoaderCard
            key={"loader" + productIndex}
            loaderImage={product.url}
            loaderIndex={productIndex}
            loaderFallbackImage={product.fallbackUrl}
          />
        </div>
      ) : (
        <div>
          <div>
            <div className="content-title_container col-12 justify-self-center">
              <span className="content-title content-title-fade">
                {words}
              </span>
              <span className="textLook col-12 justify-self-center">
                {"Look " + `${productIndex + 1}` + " of " + cardLength}
              </span>
            </div>

            {allSlotsReady && imagesLoaded ? (
              <div className="product-images-container">
                {slotsData?.map((item, index) => (
                  <div key={index} className="product-image-wrapper">
                    {imageTemplate(item.element, item.slot)}
                  </div>
                ))}
              </div>
            ) : (
              <div className="products-loading-placeholder">
              </div>
            )}
            {/* {!stopClick && ( */}
              <div>
                {
                  IsLuxeBrand?.map((luxe, index) => {
                    if(luxe !== "" && index === productIndex) {
                      return (
                        <div key={index} className="bottomTextContainerLayout">
                          {!stopClick && (
                          <button name="viewLook" className={`px-0 ${allSlotsReady && imagesLoaded ? 'animate' : ''}`} style={{ background: 'transparent', border: 'none', padding: 0, display: 'flex', outline: 'none' }}>
                            <span className="viewText" style={{ color: '#FFF', background: '#000', border: 'none' }}>+ View Look</span>
                          </button>
                          )}
                            {/* <span className="brandNameText">{formatLabel(luxe)}</span> */}
                            {/* <span className="brandNameText">{formatLabel(brandMap[luxe] || luxe)}</span> */}
                            <img src={fetchBrandImage(formatLabel(brandMap[luxe] || luxe))} alt={luxe} className="brandLogo" />
                        </div>
                      )
                    } else if(luxe === "" && index === productIndex) {
                      return (
                        <>
                        {!stopClick && (
                          <div key={"view_button_"+index} className="bottomTextContainerNonLuxe">
                          <button name="viewLook" className={`px-0 ${allSlotsReady && imagesLoaded ? 'animate' : ''}`} style={{ background: 'transparent', border: 'none', padding: 0, display: 'flex', outline: 'none' }}>
                            <span className="viewText" style={{ color: '#000', background: '#FFF', border: 'none' }}>+ View Look</span>
                          </button>
                        </div>
                        )}
                        </>
                      )
                    }
                  })
                }
              </div>
            {/* )} */}
          </div>
        </div>
      )}
    </div>
  ), [product, productIndex, words, cardLength, allSlotsReady, imagesLoaded, slotsData, imageTemplate]);

  return (
    <button
      name="looksCard"
      style={{ animationDelay: !effects ? `${productIndex * 1}s` : '' }}
      className={`box d-flex px-0 ${stopHover ? "noHover" : "effectHover"
        } col-7 col-md-4 fade-in bg-fade-in  ${productIndex === 0 && "mcat-box-ms"}`}
      onClick={categoryListing}
      disabled={loading}
    >
      {cardContent}
    </button>
  );
});

MultiProductCard.propTypes = MultiProductCardProps;

export default MultiProductCard;
